import { render, staticRenderFns } from "./research-app.vue?vue&type=template&id=9020b7ce&scoped=true"
import script from "./research-app.vue?vue&type=script&lang=js"
export * from "./research-app.vue?vue&type=script&lang=js"
import style0 from "./research-app.vue?vue&type=style&index=0&id=9020b7ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9020b7ce",
  null
  
)

export default component.exports